import Phaser from 'phaser';

// ─── Boss HUD ─────────────────────────────────────────────────────────────────
export const HUD_BAR_Y = 10;
export const HUD_BAR_HEIGHT = 8;
export const HUD_BAR_WIDTH = 200;

// ─── Glow ring ────────────────────────────────────────────────────────────────
export const GLOW_EXTRA_RADIUS = 12;

// ─── Forest boss: spawn adds + charge ─────────────────────────────────────────
export const ADD_SPAWN_MIN_RADIUS = 60;
export const ADD_SPAWN_RADIUS_VARIANCE = 40;
export const CHARGE_SPEED_MULTIPLIER = 2.5;
export const CHARGE_DURATION_MS = 1500;
export const FOREST_ATTACK_BASE_INTERVAL_MS = 5000;

// ─── Cave boss: spiral projectiles ────────────────────────────────────────────
export const CAVE_ATTACK_BASE_INTERVAL_MS = 2000;
export const PROJECTILE_SPEED = 200;
export const PROJECTILE_LIFETIME_MS = 3000;

// ─── Graveyard boss: skeleton adds ────────────────────────────────────────────
export const GRAVEYARD_ATTACK_BASE_INTERVAL_MS = 4000;
export const GRAVEYARD_SPAWN_MIN_RADIUS = 80;
export const GRAVEYARD_SPAWN_RADIUS_VARIANCE = 50;

// ─── Phase escalation multipliers ─────────────────────────────────────────────
export const PHASE_2_INTERVAL_MULT = 0.7;
export const PHASE_3_INTERVAL_MULT = 0.5;

// ─── Projectile tracking type ─────────────────────────────────────────────────
export interface BossProjectile {
  arc: Phaser.GameObjects.Arc;
  vx: number;
  vy: number;
  lifeMs: number;
}
